// Cooking techniques the kid drops into the 3rd combiner slot.
// These describe HOW the two foods are prepared together, not
// additional ingredients. Salt and water moved out — they're real
// ingredients and live in kidFoods.js.
//
// EMOJI selection avoids any emoji already used as a base food in
// kidFoods.js so the (a, b, c) cache key stays unique-per-intent.

export const KID_TECHNIQUES = [
  { id: "pan",       displayName: "Pan-Fry",   emoji: "🍳", funFact: "Sizzles food in a hot pan with butter or oil." },
  { id: "pot",       displayName: "Boil",      emoji: "🍲", funFact: "Cooks food in bubbling hot water." },
  { id: "oven",      displayName: "Bake",      emoji: "♨️", funFact: "Cooks slowly with dry hot air, all around." },
  { id: "heat",      displayName: "Heat",      emoji: "🔥", funFact: "Turns raw into cooked." },
  { id: "cold",      displayName: "Freeze",    emoji: "❄️", funFact: "Turns liquid into solid, food into a treat." },
  { id: "knife",     displayName: "Chop",      emoji: "🔪", funFact: "Cuts food into smaller pieces." },
  { id: "blender",   displayName: "Blend",     emoji: "🌀", funFact: "Spins everything together into smoothies." },
  { id: "spoon",     displayName: "Mix",       emoji: "🥄", funFact: "Stirs ingredients into a batter or sauce." },
  { id: "strain",    displayName: "Strain",    emoji: "🫖", funFact: "Pours liquid through a sieve — keeps the broth, leaves the chunks." },
  { id: "steam",     displayName: "Steam",     emoji: "💨", funFact: "Gentle wet heat — cooks without browning." },
  { id: "rest",      displayName: "Rest",      emoji: "⏳", funFact: "Just wait. Time turns milk into yogurt, grapes into wine, dough into bread." },
  { id: "store",     displayName: "Store",     emoji: "📦", funFact: "Put one food INSIDE another (a jar, a cow, a barrel). Time + vessel = magic." },
  // Pickle (🫙) and Slow Cook (⏲️) used to live here — they're now
  // expressible as combos: Pickle = Jar + Salt + ⏳ Rest,
  // Slow Cook = 🔥 Heat + ⏳ Rest. Removing them teaches kids that
  // techniques can be assembled from primitives.
  { id: "dehydrate", displayName: "Dehydrate", emoji: "🌞", funFact: "Sun-dries food to chewy snacks — raisins, jerky, banana chips." },
  { id: "squeeze",   displayName: "Squeeze",   emoji: "🤏", funFact: "Press fruit to get juice. Press olives to get oil." },
  { id: "grill",     displayName: "Grill",     emoji: "🍖", funFact: "Flames + grates = smoky char marks. BBQ time!" },
  { id: "whip",      displayName: "Whip",      emoji: "🌪️", funFact: "Beats air into food until it's fluffy and light." },
];

// Back-compat: useKidCraft was importing KID_TOOLS by name. Alias
// for stability while we transition; new callers prefer
// KID_TECHNIQUES.
export const KID_TOOLS = KID_TECHNIQUES;

// Knife sub-variants — exposed via long-press on the 🔪 Chop tile.
// Tap knife = default Chop. Hold knife = popup with these.
// Each variant produces a distinct cache key (different emoji), so
// "shave a fish" ≠ "chop a fish" downstream.
export const KNIFE_VARIANTS = [
  { id: "chop",  displayName: "Chop",  emoji: "🔪", funFact: "Big chunks. The default kitchen cut." },
  { id: "shave", displayName: "Shave", emoji: "🪒", funFact: "Paper-thin curls — bonito flakes, shaved parmesan, truffle ribbons." },
  { id: "slice", displayName: "Slice", emoji: "✂️", funFact: "Even thin slices for sandwiches and stacks." },
];

export function techniqueById(id) {
  return KID_TECHNIQUES.find((t) => t.id === id) || null;
}

export function techniqueByEmoji(emoji) {
  return KID_TECHNIQUES.find((t) => t.emoji === emoji) || null;
}
